import request from '@/config/axios'
export const GetAccountMe = (params) => {
  return request.get({
    baseUrl: 'apm-auth',
    url: '/auth/api/v1/account/me',
    params
  })
}

export const UpdateComponent = (data) => {
  return request.post({
    url: '/api-apm/api/v2/node/component/list',
    data
  })
}

export const GetComponents = (params) => {
  return request.get({
    url: '/api-apm/api/v1/component',
    params
  })
}

export const GetLabels = (params) => {
  return request.get({
    url: '/api-apm/api/v1/label',
    params
  })
}
/******** template start*********** */
//查询所有模板
export const GetAllTemplates = () => {
  return request.get({
    url: '/api-apm/api/v1/template',
    params:{
      index:0,
      count:1000,
      class: 'custom'
    }
  })
}

//模板同步组件到节点
export const SyncTemplateComponents = (data) => {
  return request.post({
    url: '/api-apm/api/v1/template/sync',
    data
  })
}
// 模板同步组件进度查询 {id:templateId 模板ID}
export const SyncComponentsStatus = (params) => {
  return request.get({
    url: '/api-apm/api/v1/template/sync/status',
    params
  })
}

export const UpdateTemplateComponents = (data) => {
  return request.put({
    url: '/api-apm/api/v1/template/component/list',
    data
  })
}
//最多1000条
export const GetTemplateComponentByIds = (params) => {
  return request.get({
    url: '/api-apm/api/v1/template/component',
    params
  })
}

export const DeleteTemplateComponent = (id,templateId) => {
  return request.delete({
    url: `/api-apm/api/v1/template/component?id=${id}&templateId=${templateId}`,
  })
}


export const UpdateTemplateProperties = (data) => {
  return request.put({
    url: '/api-apm/api/v1/template/property/list',
    data
  })
}
//最多1000条
export const GetTemplatePropertyByIds = (params) => {
  return request.get({
    url: '/api-apm/api/v1/template/property/byid/list',
    params
  })
}
//模板获取输出参数
export const GetTemplateCalcItems = (params) => {
  return request.get({
    url: '/api-apm/api/v1/template/property/calcItems',
    params
  })
}
/******** template end********** */
export const GetNodeProperty = (params) => {
  return request.get({
    url: '/api-apm/api/v2/node/property',
    params
  })
}
//最多1000条
export const GetNodePropertyByIds = (params) => {
  return request.get({
    url: '/api-apm/api/v1/node/property/byid/list',
    params
  })
}

export const GetNodesByGroup = (params) => {
  return request.get({
    url: '/api-apm/api/v1/asset/node/bygroup',
    params
  })
}

export const GetGroupByProject = (data) => {
  return request.post({
    url: '/api-apm/api/v1/asset/group/byproject',
    data
  })
}

export const GetHistRawData = (data) => {
  return request.post({
    url: '/api-apm/api/v1/hist/raw/data',
    data
  })
}

export const GetLatestData = (data) => {
  return request.post({
    url: '/api-apm/api/v1/latest/data',
    data
  })
}

//获取报警分类
export const GetAlarmCategory = (params) => {
  return request.get({
    url: '/api-apm/api/v1/alarmcategory/bygroupornode',
    params
  })
}


/*****  alarm-process ***** */
export const GetEventList = (data) => {
  return request.post({
    url: '/alarm-process/api/v1/event/list',
    data
  })
}

export const GetEventTimes = (data) => {
  return request.post({
    url: '/alarm-process/api/v1/event/times',
    data
  })
}

/*****  measure ***** */
export const GetRollbackLogs = (data) => {
  return request.post({
    url: '/api/v2/metric/rollback/record',
    data,
    baseUrl:'apm-measure'
  })
}